<template>
  <b-tr>
    <b-td>
      <span class="text-primary">{{ category.name | split }} +</span>
    </b-td>
    <b-td>
      {{ meal.label | split }}
    </b-td>
    <b-td>
      <span class="pointer"
        :style="'text-decoration:' + (meal.discount ? 'line-through' : '')"
        @click="$emit('priceDetails')"
        >
        &euro;{{ getFullPrice({ meal, starRating, fees }) }}
      </span>
    </b-td>
    <b-td >
      <span class="pointer"
        @click="$emit('priceDetails')"
        v-if="meal.discount"
        :class="meal.discount ? 'sale-price':'info-price.full-price'"
        >
        &euro;{{ getPrice({ meal, starRating, fees }) }}
      </span>
    </b-td>
    <b-td>
      <span v-if="category.isSpecial" class="SPO" v-b-tooltip.hover :title="$gettext('Special Offer')">
        <b-icon icon="tag-fill" class="text-danger"/>
      </span>
      <span v-if="category.isEarlyBooking" class="BD" v-b-tooltip.hover :title="$gettext('Early Booking')">
        <b-icon icon="clock" class="text-info"/>
      </span>
      <span v-if="category.isFreePax" class="FC" v-b-tooltip.hover :title="$gettext('Free Child')">
        <b-icon icon="person-plus-fill"/>
      </span>
    </b-td>
    <b-td v-if="transport ==='own'">
       <span v-if="status=='avl'" class="FCAVL" v-b-tooltip.hover :title="$gettext('Available')">
        <b-icon icon="check-circle" class="text-success"/>
      </span>
      <span v-if="status=='n/a'" class="RQNA" v-b-tooltip.hover :title="$gettext('Unavailable')">
        <b-icon icon="slash-circle"/>
      </span>
    </b-td>
    <b-td class="text-center">
     <span v-if="status=='avl'" class="FCAVL" v-b-tooltip.hover :title="$gettext('Available')">
        <b-icon icon="check-circle" class="text-success"/>
      </span>
      <span v-if="status=='n/a'" class="RQNA" v-b-tooltip.hover :title="$gettext('Unavailable')">
        <b-icon icon="slash-circle"/>
      </span>
      <span v-if="status=='req'" class="RQNA" v-b-tooltip.hover :title="$gettext('On Request')">
        <b-icon icon="check-circle"/>
      </span>
    </b-td>
    <b-td class="text-right">
      <!-- <b-btn
        size="sm"
        :variant="(status == 'req') ? 'secondary': 'success'"
        type="button"
        @click="$emit('book')"
      >{{ (status == 'req') ? $gettext('On Request') : $gettext('Book') }}</b-btn>-->
    </b-td>
  </b-tr>
</template>

<script>
import { getFullPrice, getPrice } from 'b2b-common/utils/hotel'
import viewMixin from '../mixins/search_views'

export default {
  props: {
    meal: {
      type: Object,
      required: true
    },
    category: {
      type: Object,
      required: true
    },
    transport: {
      type: String
    },
    starRating: {
      type: Number,
      default: 0
    },
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  mixins: [viewMixin],
  computed: {
    status () {
      let status = 'req'
      if (this.category.hotelIsBlackedOut) status = 'n/a'
      if (this.category.hotelIsAvailable) status = 'avl'
      return status
    }
  },
  methods: {
    getPrice,
    getFullPrice
  }
}
</script>

<style lang="css">
  .pointer {
    cursor:pointer;
  }
  .full-price,
  .info-price {
    font-weight: 400;
  }
  .full-price{
    color:#555;
    font-size: .8rem;
  }
  .sale-price{
    color: #d13239;
    font-weight: 600;
  }
</style>
